import { Component, computed, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { getShipSpeed, getTowMileageStats } from '@cpr/shared/cpr-math';
import type { TowRouteData } from '../../interface/tow-route-data.interface';

@Component({
  selector: 'app-tow-log-screen',
  template: `
    <app-header>
      <cpr-sample-generation-button />
      <cpr-printout-menu />
    </app-header>

    @if (routeData.towLog(); as towLog) {
      <div style="display: grid; grid-template-columns: min-content auto; gap: 24px; margin: 24px">
        <mat-card style="min-width: 300px">
          <mat-card-content>
            @if (routeData.tow()?.metadata; as md) {
              <div>
                <b>Towed miles:</b>
                {{ (towMileageStats()?.towMileage | number: '1.0-2') ?? 'N/A' }}
              </div>
              <div>
                <b>Sampled miles:</b>
                {{ (towMileageStats()?.sampledMileage | number: '1.0-2') ?? 'N/A' }}
              </div>
              <div>
                <b>Average speed:</b>
                {{ (shipSpeed() | number: '1.0-2') ?? 'N/A' }}
              </div>
              <div>
                <b>Miles per division:</b>
                {{ (towMileageStats()?.milesPerDivision | number: '1.0-2') ?? 'N/A' }}
              </div>

              <hr />

              <div>
                <b>Silk start reading:</b>
                {{ md.silkReadingStart ?? 'Not set' }}
              </div>
              <div>
                <b>Silk end reading:</b>
                {{ md.silkReadingEnd ?? 'Not set' }}
              </div>
            }
          </mat-card-content>
        </mat-card>

        <app-tow-log-map-tile height="300px" [interactive]="editMode()" />

        <app-tow-log-data-table
          style="grid-area: 2/1/2/span 2"
          (editModeState)="editMode.set($event)"
        />
      </div>
    } @else {
      <mat-spinner />
    }
  `,
})
export class TowLogScreenComponent {
  protected readonly routeData = inject(ActivatedRoute).snapshot.data as TowRouteData;

  readonly editMode = signal<boolean>(false);

  readonly mathContext = computed(() => ({
    tow: this.routeData.tow().metadata,
    towLog: this.routeData.towLog(),
  }));

  readonly towMileageStats = computed(() => {
    try {
      return getTowMileageStats(this.mathContext());
    } catch (e) {
      console.error(e);
      return null;
    }
  });

  readonly shipSpeed = computed(() => {
    try {
      return getShipSpeed(this.mathContext());
    } catch (e) {
      console.error(e);
      return null;
    }
  });
}
